import React from 'react';
import { useNavigate } from 'react-router-dom';
import SectionHead from './SectionHead';

function Solutions({ data }) {
  const navigate = useNavigate();

  const handleGetEnquiry = (item) => {
    navigate('/demo', { 
      state: { 
        product: {
          title: item.title,
          description: item.copy,
        }
      } 
    });
  };

  return (
    <section className="section" id="solutions">
      <SectionHead title={data.title} copy={data.copy} />
      <div className="grid cards products-grid">
        {data.items.map((item) => (
          <article className="card product-card" key={item.title}>
            <h3>{item.title}</h3>
            <p>{item.copy}</p>
            <ul>
              {item.bullets.map((bullet) => (
                <li key={bullet}>{bullet}</li>
              ))}
            </ul>
            <div className="product-actions">
              <button
                className="primary"
                onClick={() => handleGetEnquiry(item)}
              >
                Get Enquiry
              </button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Solutions;
